import { PermissionAction, PermissionResource } from '@entities/client/permission';

import { ENV } from '@shared/config';
import { NavigationPointer01Icon, Droplets02Icon, FolderIcon } from '@shared/ui/icons';
import type { ClientNavItem } from '../model';

import { sx } from './navigation-icon-sx';

export const settingsNavigationItems: ClientNavItem[] = [
  { label: 'Маршрутний лист', icon: <NavigationPointer01Icon sx={sx} /> },
  ...(ENV.IS_DEVELOPMENT_MODE
    ? [{ label: 'UI Kit', path: '/ui-kit', icon: <FolderIcon sx={sx} /> }]
    : []),
  {
    label: 'Каса',
    path: '/checkout',
    resource: PermissionResource.MachineOrders,
    action: PermissionAction.Write,
    icon: <Droplets02Icon sx={sx} />,
  },
];
